var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarDateIcon = function SvgCalendarDateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0057B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.25 8.334H2.95m11.772-6.667V5M7.477 1.667V5m2.264 6.667 1.358-.833V15m-1.132 0h2.264m-4.935 3.334h7.607c1.521 0 2.282 0 2.863-.273a2.62 2.62 0 0 0 1.187-1.092c.297-.535.297-1.235.297-2.635v-7c0-1.4 0-2.1-.297-2.635a2.62 2.62 0 0 0-1.187-1.093c-.581-.272-1.342-.272-2.863-.272H7.296c-1.522 0-2.282 0-2.863.272-.512.24-.927.622-1.188 1.093-.296.534-.296 1.235-.296 2.635v7c0 1.4 0 2.1.296 2.635.26.47.676.852 1.188 1.092.58.273 1.341.273 2.863.273"
  })));
};
export default SvgCalendarDateIcon;